module.exports = __webpack_public_path__ + "static/event-image-2-2ddf9f0308014aa0114a2e67bfc6e048.jpg";